import { defineMessages } from 'react-intl'

export default defineMessages({
  details: {
    id: 'ErrorComponent.Details',
    defaultMessage: 'Details'
  },
  genericMessage: {
    id: 'ErrorComponent.Generic.Message',
    defaultMessage: 'Something went wrong...'
  },
  genericTitle: {
    id: 'ErrorComponent.Generic.Title',
    defaultMessage: 'An error has occurred'
  },
  genericSubMessage: {
    id: 'ErrorComponent.Generic.SubMessage',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  },
  genericInternalServerErrorMessage: {
    id: 'ErrorComponent.Generic.InternalServerError.Message',
    defaultMessage: 'Something went wrong...'
  },
  genericInternalServerErrorTitle: {
    id: 'ErrorComponent.Generic.ServerError.Title',
    defaultMessage: 'An error has occurred'
  },
  genericInternalServerErrorSubMessage: {
    id: 'ErrorComponent.Generic.InternalServerError.SubMessage',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail  ."
  },
  genericGatewayTimeoutErrorMessage: {
    id: 'ErrorComponent.Generic.GatewayTimeout.Message',
    defaultMessage: 'Our systems are a little overworked right now. Please come back in a few minutes.'
  },
  genericGatewayTimeoutErrorTitle: {
    id: 'ErrorComponent.Generic.GatewayTimeout.Title',
    defaultMessage: 'An error has occurred'
  },
  genericGatewayTimeoutErrorSubMessage: {
    id: 'ErrorComponent.Generic.GatewayTimeout.SubMessage',
    defaultMessage:
      "It's not you, it's us. The system is taking a little longer than normal to process your request. Wait a few minutes and try again."
  },
  genericBadRequestErrorMessage: {
    id: 'ErrorComponent.Generic.BadRequest.Message',
    defaultMessage: 'Something went wrong...'
  },
  genericBadRequestErrorTitle: {
    id: 'ErrorComponent.Generic.BadRequest.Title',
    defaultMessage: 'An error has occurred'
  },
  genericBadRequestErrorSubMessage: {
    id: 'ErrorComponent.Generic.BadRequest.SubMessage',
    defaultMessage:
      "It's not you, it's us. There was a problem with the system which caused your request to be rejected."
  },
  genericUnauthorizedErrorTitle: {
    id: 'ErrorComponent.Generic.Unauthorized.Title',
    defaultMessage: 'You do not have access permissions'
  },
  genericUnauthorizedErrorMessage: {
    id: 'ErrorComponent.Generic.Unauthorized.Message',
    defaultMessage: 'Consult your organization administrator to request access.'
  },
  genericPayloadToBigErrorTitle: {
    id: 'ErrorComponent.Generic.PayloadToBig.Title',
    defaultMessage: 'An error has occurred'
  },
  genericPayloadToBigErrorMessage: {
    id: 'ErrorComponent.Generic.PayloadToBig.Message',
    defaultMessage: 'Something went wrong...'
  },
  genericPayloadToBigErrorSubMessage: {
    id: 'ErrorComponent.Generic.PayloadToBig.SubMessage',
    defaultMessage: "It's not you, it's us. There was a problem sending your request to the system."
  },
  genericNotFoundErrorTitle: {
    id: 'ErrorComponent.Generic.NotFound.Title',
    defaultMessage: 'Resource not found'
  },
  genericNotFoundErrorMessage: {
    id: 'ErrorComponent.Generic.NotFound.Message',
    defaultMessage: 'The resource you are trying to access does not exist'
  },
  genericWorkgridSupportMessage: {
    id: 'ErrorComponent.Generic.Support.Message',
    defaultMessage: 'Contact Workgrid Support'
  }
})
